import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuComponent } from './component/menu/menu.component';
import { FooterComponent } from './component/footer/footer.component';
import { MenuItemDesktopComponent } from './component/menu/menu-item-desktop/menu-item-desktop.component';
import { HomeComponent } from './page/home/home.component';
import { GdprComponent } from './page/gdpr/gdpr.component';
import { ContactComponent } from './page/contact/contact.component';
import { HamburgerMenuComponent } from './component/menu/hamburger-menu/hamburger-menu.component';
import { MenuItemMobileComponent } from './component/menu/hamburger-menu/menu-item-mobile/menu-item-mobile.component';
import { MenuItemComponent } from 'projects/max/dfup-storeupweb-fe/src/app/component/menu/menu-item/menu-item.component';
import { BusinessConditionsComponent } from './page/business-conditions/business-conditions.component';
import { EmailComponent } from './component/email/email.component';
import { I18nModule } from 'shared/module/i18n/i18n.module';
import { appInitFactory, StartUpService } from 'projects/max/dfup-storeupweb-fe/src/app/service/start-up.service';
import {
  LangPickerComponent
} from 'projects/max/dfup-storeupweb-fe/src/app/component/menu/lang-picker/lang-picker.component';

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    FooterComponent,
    MenuItemDesktopComponent,
    HomeComponent,
    GdprComponent,
    ContactComponent,
    HamburgerMenuComponent,
    MenuItemMobileComponent,
    MenuItemComponent,
    BusinessConditionsComponent,
    EmailComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    I18nModule,
    LangPickerComponent
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: appInitFactory,
      deps: [StartUpService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
